// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalInventoryLogs_root__2shjU","log":"ModalInventoryLogs_log__RtieC","date":"ModalInventoryLogs_date__2PTKw","userName":"ModalInventoryLogs_userName__1zmRs"};